module.exports = __webpack_public_path__ + "img/rullet_hillstate.b79daa4b.png";